import ExportBoxesService from '@/services/export/ExportBoxesService'

const localCurrentExportBox = JSON.parse(localStorage.getItem('currentExportBox'))
const localCurrentVirtualExportBoxContentCount = JSON.parse(localStorage.getItem('virtualBoxContentCount'))
const initCurrentExportBox = localCurrentExportBox || null

export default {
  namespaced: true,
  state: {
    exportBoxesList: [],
    currentExportBox: initCurrentExportBox,
    exportBoxContent: [],
    currentContentExportBox: null,
    virtualExportBoxContentCount: localCurrentVirtualExportBoxContentCount || 0,
    currentBoxContentIds: new Set()
  },
  getters: {
    exportBoxesList: state => state.exportBoxesList,
    currentExportBox: state => state.currentExportBox,
    exportBoxContent: state => state.exportBoxContent,
    currentExportBoxId: state => {
      if (state.currentExportBox) {
        return state.currentExportBox.id
      }
      return 0
    },
    currentBoxContentIds: state => state.currentBoxContentIds
  },
  actions: {
    addArtworkToExportBox ({ commit, state, rootGetters }, { boxId, artwork }) {
      return ExportBoxesService.addArtworkToExportBox(boxId, artwork.id).then(response => {
        if (boxId === state.currentExportBox.id) {
          commit('INCREMENT_VIRTUAL_BOX_CONTENT_COUNT')
          state.currentExportBox.contentCount++
          if (!state.currentBoxContentIds.has(artwork.id)) {
            state.currentBoxContentIds.add(artwork.id)
          }
          const filterArtwork = rootGetters['artworks/currentFilterList'].find(a => a.id === artwork.id)
          if (filterArtwork) {
            filterArtwork.isInExportBox = true
          }
        }
        return response
      }, error => {
        return Promise.reject(error)
      })
    },
    removeArtworkFromExportBox ({ commit, state, rootGetters }, { boxId, artwork }) {
      return ExportBoxesService.removeArtworkFromExportBox(boxId, artwork.id).then(_ => {
        if (boxId === state.currentExportBox.id) {
          commit('DECREMENT_VIRTUAL_BOX_CONTENT_COUNT')
          state.currentExportBox.contentCount--
          if (state.currentBoxContentIds.has(artwork.id)) {
            state.currentBoxContentIds.delete(artwork.id)
          }
          const filterArtwork = rootGetters['artworks/currentFilterList'].find(a => a.id === artwork.id)
          if (filterArtwork) {
            filterArtwork.isInExportBox = false
          }
        }
        return commit('DELETE_EXPORT_BOX_CONTENT', artwork)
      }, error => {
        return Promise.reject(error)
      })
    },
    refreshExportBoxContent ({ commit }, box) {
      return ExportBoxesService.getExportBoxContent(box.id).then(list => {
        commit('SET_EXPORT_BOX_CONTENT', list)
        commit('SET_EXPORT_BOX_CONTENT_IDS', list)
        commit('SET_CURRENT_CONTENT_EXPORT_BOX', box)
      }, error => {
        return Promise.reject(error)
      })
    },
    setCurrentExportBox ({ commit, state }, exportBox) {
      localStorage.setItem('currentExportBox', JSON.stringify(exportBox))
      commit('SET_EXPORT_BOX', exportBox)
      if (state.currentExportBox) {
        commit('UPDATE_VIRTUAL_BOX_CONTENT_COUNT_BY_CURRENT_BOX')
      }
    },
    refreshExportBoxes ({ commit }) {
      return ExportBoxesService.getAllExportBoxes()
        .then(list => {
          commit('SET_EXPORT_BOXES', list)
        })
    },
    addNewExportBox ({ commit }, exportBox) {
      return ExportBoxesService.saveExportBox(exportBox).then(result => {
        exportBox.id = result.data.id
        commit('ADD_EXPORT_BOX', exportBox)
        return exportBox
      })
    },
    editExportBox ({ commit }, exportBox) {
      return ExportBoxesService.saveExportBox(exportBox).then(result => {
        commit('EDIT_EXPORT_BOX', exportBox)
        return exportBox
      })
    },
    deleteExportBox ({ commit, state }, exportBox) {
      if (exportBox.id === state.currentExportBox.id) {
        commit('SET_EXPORT_BOX', null)
      }
      return ExportBoxesService.removeExportBox(exportBox).then(result => {
        commit('DELETE_EXPORT_BOX', exportBox)
      })
    }
  },
  mutations: {
    SET_CURRENT_CONTENT_EXPORT_BOX (state, box) {
      state.currentContentExportBox = box
    },
    INCREMENT_VIRTUAL_BOX_CONTENT_COUNT (state) {
      state.virtualExportBoxContentCount++
      localStorage.setItem('virtualBoxContentCount', JSON.stringify(state.virtualExportBoxContentCount))
    },
    DECREMENT_VIRTUAL_BOX_CONTENT_COUNT (state) {
      state.virtualExportBoxContentCount--
      localStorage.setItem('virtualBoxContentCount', JSON.stringify(state.virtualExportBoxContentCount))
    },
    UPDATE_VIRTUAL_BOX_CONTENT_COUNT_BY_CURRENT_BOX (state) {
      state.virtualExportBoxContentCount = state.currentExportBox.contentCount
      localStorage.setItem('virtualBoxContentCount', JSON.stringify(state.virtualExportBoxContentCount))
    },
    SET_EXPORT_BOX_CONTENT (state, exportBoxContent) {
      state.exportBoxContent = exportBoxContent
    },
    SET_EXPORT_BOX_CONTENT_IDS (state, exportBoxContent) {
      state.currentBoxContentIds = new Set()
      for (let i = 0; i < exportBoxContent.length; i++) {
        state.currentBoxContentIds.add(exportBoxContent[i].id)
      }
    },
    SET_EXPORT_BOX (state, exportBox) {
      state.currentExportBox = exportBox
    },
    SET_EXPORT_BOXES (state, list) {
      state.exportBoxesList = list
    },
    EDIT_EXPORT_BOX (state, exportBox) {
      const current = state.exportBoxesList[exportBox.index]
      current.name = exportBox.name
    },
    ADD_EXPORT_BOX (state, exportBox) {
      const newExportBox = {
        id: exportBox.id,
        name: exportBox.name,
        contentCount: 0
      }
      state.exportBoxesList.push(newExportBox)
    },
    DELETE_EXPORT_BOX (state, exportBox) {
      state.exportBoxesList.splice(exportBox.index, 1)
    },
    DELETE_EXPORT_BOX_CONTENT (state, simpleArtwork) {
      state.exportBoxContent.splice(simpleArtwork.index, 1)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/export/exportBoxes.js